import { fetchPatients } from '@/layers/presentation/services/patients';
import logger from '@/layers/support/monitoring/logger';
import { PatientExtended } from '@/types/models';
import { useEffect, useState } from 'react';

const LOG_MODULE = 'FE [Presentation / Hooks / Patient]';

export function usePatientsList(filters: Record<string, any[]>) {
  const [patients, setPatients] = useState<PatientExtended[]>([]);
  const [loadingPatients, setLoadingPatients] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  logger.debug(`${LOG_MODULE} usePatientsList`, {
    filters,
    patients,
    loadingPatients,
    error,
  });

  useEffect(() => {
    const fetchPatientsData = async () => {
      try {
        const fetchedPatients = await fetchPatients(filters);
        setPatients(fetchedPatients);
        setError(null);
      } catch (error) {
        setError((error as Error).message);
        setPatients([]);
      } finally {
        setLoadingPatients(false);
      }
    };

    if (Object.keys(filters).length > 0) {
      setLoadingPatients(true);
      fetchPatientsData();
    } else {
      setPatients([]);
      setLoadingPatients(false);
    }
  }, [filters]);

  return { patients, loadingPatients, error };
}
